// Interceptar todos os erros JavaScript não capturados
window.addEventListener('error', (event) => {
  console.error('🚨 Global Error Handler - Erro JavaScript:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack,
    timestamp: new Date().toISOString()
  });
});

// Interceptar promissões rejeitadas não capturadas
window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 Global Error Handler - Promise rejeitada:', {
    reason: event.reason,
    promise: event.promise,
    message: event.reason?.message,
    stack: event.reason?.stack,
    timestamp: new Date().toISOString()
  });
});

// Interceptar erros de rede/resources
window.addEventListener('error', (event) => {
  if (event.target !== window) {
    const target = event.target as any;
    console.error('🚨 Global Error Handler - Erro de resource:', {
      type: target?.tagName,
      source: target?.src || target?.href,
      message: event.message,
      timestamp: new Date().toISOString()
    });
  }
}, true);

console.log('📊 Global Error Handlers configurados');

export {};